module.exports = __webpack_public_path__ + "c7fcc7e62503a24c34e132f602d55545.fbx";